import React from "react";

interface Props {
    settings: any,
    setSettings: any
}
const VehicleOwnerCalendar = (props: Props) => {
    const { } = props;
    return(
        <>
            <span>vehicleOwnerCalendar</span>
        </>
    );
}

export default VehicleOwnerCalendar;